import type { RouteObject } from "react-router-dom";
import { addSlashes } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import { MsDigitalId, MsDigitalIdSubmissions } from "@/utils/lazyLoadComponents";

export enum MS_DIGITAL_ID_PATH_SEGMENTS {
  ROOT = "digital-id",
  SUBMISSIONS = "submissions",
}

export const mySpaceDigitalIdRoutes: RouteObject = {
  path: MS_DIGITAL_ID_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Digital ID" },
  HydrateFallback: Spinner,
  children: [
    {
      index: true,
      Component: MsDigitalId,
    },
    {
      path: MS_DIGITAL_ID_PATH_SEGMENTS.SUBMISSIONS,
      handle: { breadcrumb: "Submissions" },
      Component: MsDigitalIdSubmissions,
    },
  ],
};

export const MS_DIGITAL_ID_PATHS = Object.freeze({
  ROOT: addSlashes(MS_DIGITAL_ID_PATH_SEGMENTS.ROOT),
  SUBMISSIONS: addSlashes(
    `${MS_DIGITAL_ID_PATH_SEGMENTS.ROOT}/${MS_DIGITAL_ID_PATH_SEGMENTS.SUBMISSIONS}`,
  ),
});
